import React from 'react'

export function RadioEmpty() {
	return (
		<svg width="19px" height="19px" viewBox="0 0 19 19">
			<circle
				fill="none"
				strokeWidth="1"
				stroke="#C8CDD2"
				cx="9.5"
				cy="9.5"
				r="8.5"
			/>
		</svg>
	)
}

export function RadioFilled() {
	return (
		<svg width="19px" height="19px" viewBox="0 0 19 19">
			<circle
				fill="none"
				strokeWidth="1"
				stroke="#C8CDD2"
				cx="9.5"
				cy="9.5"
				r="8.5"
			/>
			<circle
				fill="#44474D"
				cx="9.5"
				cy="9.5"
				r="4.5"
			/>
		</svg>
	)
}
